export default "__VITE_ASSET__DyhXNP$U__";